import { Button } from '@/common/ui/button'
import {
	Dialog,
	DialogContent,
	DialogHeader,
	DialogTitle,
	DialogTrigger,
} from '@/common/ui/dialog'
import {
	Form,
	FormControl,
	FormField,
	FormItem,
	FormMessage,
} from '@/common/ui/form'
import { Input } from '@/common/ui/input'
import useMutationUpdateBrokeNotification from '@/modules/client-setting/api/hooks/useMutationUpdateBrokeNotification'
import { BrokeNotificationQueryKeys } from '@/modules/client-setting/keys'
import {
	BrokeNotificationData,
	UpdateBrokeNotificationRequest,
} from '@/modules/client-setting/type'
import { zodResolver } from '@hookform/resolvers/zod'
import { useQueryClient } from '@tanstack/react-query'
import { Edit } from 'lucide-react'
import { useState } from 'react'
import { useForm } from 'react-hook-form'
import { toast } from 'sonner'
import showErrorToast from '@/common/utils/showErrorToast'
import * as z from 'zod'

const formSchema = z.object({
	order: z
		.number({ invalid_type_error: 'กรุณากรอกลำดับ' })
		.min(0, 'ลำดับต้องมากกว่าหรือเท่ากับ 0'),
})

interface EditOrderProps {
	row: BrokeNotificationData
}

export default function EditOrder({ row }: EditOrderProps) {
	const [open, setOpen] = useState(false)
	const { mutate: updateBrokeNotification } =
		useMutationUpdateBrokeNotification()
	const queryClient = useQueryClient()

	const form = useForm<z.infer<typeof formSchema>>({
		resolver: zodResolver(formSchema),
		defaultValues: {
			order: row.order,
		},
	})

	const onSubmit = (values: z.infer<typeof formSchema>) => {
		updateBrokeNotification(
			{
				id: row.id,
				payload: {
					order: values.order,
				} as unknown as UpdateBrokeNotificationRequest,
			},
			{
				onSuccess: () => {
					toast.success('อัพเดทลำดับสำเร็จ')
					queryClient.invalidateQueries({
						queryKey: [BrokeNotificationQueryKeys.GetBrokeNotifications],
					})
					setOpen(false)
				},
				onError: (error) => {
					showErrorToast(error)
				},
			},
		)
	}

	return (
		<Dialog open={open} onOpenChange={setOpen}>
			<DialogTrigger asChild>
				<Button variant="ghost" size="icon">
					<Edit className="h-4 w-4" />
				</Button>
			</DialogTrigger>
			<DialogContent className="sm:max-w-[425px]">
				<DialogHeader>
					<DialogTitle>แก้ไขลำดับ</DialogTitle>
				</DialogHeader>
				<Form {...form}>
					<form
						onSubmit={form.handleSubmit(onSubmit)}
						className="grid gap-4 py-4"
					>
						<FormField
							control={form.control}
							name="order"
							render={({ field }) => (
								<FormItem>
									<FormControl>
										<Input
											type="number"
											placeholder="ลำดับ"
											{...field}
											onChange={(e) => {
												const value = e.target.value
												field.onChange(value === '' ? null : Number(value))
											}}
										/>
									</FormControl>
									<FormMessage />
								</FormItem>
							)}
						/>
						<Button type="submit" disabled={form.formState.isSubmitting}>
							บันทึก
						</Button>
					</form>
				</Form>
			</DialogContent>
		</Dialog>
	)
}
